exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dark-theme{background:#1f2d3d;color:#fff;border-radius:5px}.dark-theme[x-placement^=top] .popper__arrow:after{border-top-color:#1f2d3d}.popper-line .el-row{word-break:break-all;padding:3px 0}.popper-line .el-row:not(:first-child){border-top:1px solid #415062;margin-top:1px}.exam-name-span{max-width:95px;display:inline-block;overflow:hidden;text-overflow:ellipsis;vertical-align:bottom}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e506567","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/written/writtenList.vue
// module id = 919
// module chunks = 23